
import FirstLogin from "../Components/UI/FirstLogin/FirstLogin";
import Redirect from "../Components/UI/Redirect";
import AuthContainer from "../Containers/AuthContainer";
import LayoutContainer from "../Containers/LayoutContainer";
import { Roles } from "../utils/enums";
import AdminPage from "../Views/Admin";
import ClineItem from "../Views/C-lineItem";
import ClineItemDemo from "../Views/C-lineItemDemo";
import CTargeting from "../Views/C-targeting";
import Campaigns from "../Views/Campaigns";
import OPCreativeUpload from "../Views/OPCreativeUpload";
import CreativeUpload from "../Views/CreativeUpload/index";
import EventsLogger from "../Views/EventsLogger";
import AdsImpressions from "../Views/AdsImpressions";
//import HomePage from "../Views/Homepage";
import ImageUploader from "../Views/ImageUpload";
// import JSConfigView from "../Views/JsConfig";
import Login from "../Views/Login";
// import Login from "../Views/Login";
import NotFound from "../Views/NotFound";
import OPReportingView from "../Views/OPReporting";
import TargetingConfig from "../Views/RetargetingConfig";
//import S3UploadView from "../Views/S3Upload";
import YallaView from "../Views/Yalla";
import GLU from "../Views/GLU";
import Html5Generator from '../Views/HTML5-Generator';
import UsageReport from "../Views/UsageReport";
import BidRequests from "../Views/BidRequests";
import RealtimeMonitor from "../Views/RealtimeMonitor";
import UserManagement from "../Views/UserManagement";
import AdsDashboard from "../Views/AdsDashboard";
import UserInfo from "../Views/UserInfo";
import UserInfoV2 from "../Views/UserInfoV2";
import Yandex from "../Views/Yandex";
import UserInfoNG from "../Views/UserInfoNG";

export const AuthRoutes = [
    {
        path: '/redirect',
        element: <AuthContainer />,
        children: [
            {
                index: true,
                element: <Redirect />,
            },
        ],
    },
    {
        path: '/login',
        element: <AuthContainer />,
        children: [
            {
                index: true,
                element: <Login />
            },
        ]
    },
    {
        path: '/homepage',
        element: <AuthContainer />,
        children: [
            {
                index: true,
                element: <Login />,//<HomePage />,
            },
        ],
    },

    {
        path: '/firstLogin',
        element: <FirstLogin />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
]

export const Routes = [
    {
        path: '/admin',
        title: 'ADMIN',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN],
        children: [
            {
                index: true,
                element: <AdminPage />,
            },
        ],
    },
    {
        path: '/adsDashboard',
        title: 'ADS-DASHBOARD',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.ADSD],
        children: [
            {
                index: true,
                element: <AdsDashboard />,
            },
        ],
    },
    {
        path: '/imageTester',
        title: 'IMAGE-TESTER',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.TAGGER, Roles.TESTER],
        children: [
            {
                index: true,
                element: <ImageUploader />,
            },
        ],
    },
    // {
    //     path: '/s3Loader',
    //     title: 'S3-UPLOADER',
    //     element: <LayoutContainer />,
    //     permission: [Roles.ADMIN, Roles.SEGMENT],
    //     children: [
    //         {
    //             index: true,
    //             element: <S3UploadView />,
    //         },
    //     ],
    // },
    {
        path: '/bidRequests',
        title: 'Bid Requests',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.BID_REQUESTS],
        children: [
            {
                index: true,
                element: <BidRequests/>,
            },
        ],
    },
    {
        path: '/realtimeMonitor',
        title: 'Realtime Monitor',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.REALTIME_MONITOR],
        children: [
            {
                index: true,
                element: <RealtimeMonitor/>,
            },
        ],
    },
    {
        path: '/targeting',
        title: 'TARGETING-CONFIG',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.SEGMENT],
        children: [
            {
                index: true,
                element: <TargetingConfig />,
            },
        ],
    },
    {
        path: '/uploadAudience',
        title: 'UPLOAD AUDIENCE',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.CTARGET],
        children: [
            {
                index: true,
                element: <CTargeting />,
            },
        ],
    },
    {
        path: '/manager',
        title: 'TAG-GENERATOR',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.TAGGER],
        children: [
            {
                index: true,
                element: <YallaView />,
            },
        ],
    },
    {
        path: '/reporter',
        title: 'OPREPORTING',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.OPREPORTING],
        children: [
            {
                index: true,
                element: <OPReportingView />,
            },
        ],
    },
    // {
    //     path: '/jsConfig',
    //     title: 'JS-CONFIG',
    //     element: <LayoutContainer />,
    //     permission: [Roles.ADMIN, Roles.SPECIAL, Roles.JS_CONFIG],
    //     children: [
    //         {
    //             index: true,
    //             element: <JSConfigView />,
    //         },
    //     ],
    // },
    {
        path: '/Campaigns',
        title: 'Campaigns',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.CAMP],
        children: [
            {
                index: true,
                element: <Campaigns />,
            },
        ],
    },
    {
        path: '/eventsLogger',
        title: 'Events-Logger',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.CLOGGER],
        children: [
            {
                index: true,
                element: <EventsLogger />,
            },
        ],
    },
    {
        path: '/adsImpressions',
        title: 'Ads Impressions',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.AIMP],
        children: [
            {
                index: true,
                element: <AdsImpressions/>,
            },
        ],
    },
    {
        path: '/ipFiltering',
        title: 'PROD IP-FILTERING',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.PROD_FILTERING],
        children: [
            {
                index: true,
                element: <ClineItem />,
            },
        ],
    },
    {
        path: '/ipFilteringDemo',
        title: 'DEMO IP-FILTERING',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.DEMO_FILTERING],
        children: [
            {
                index: true,
                element: <ClineItemDemo />,
            },
        ],
    },
    {
        path: '/opCreativeUpload',
        title: 'OP-CREATIVE-UPLOAD',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.OP_CREATIVE_UPLOAD],
        children: [
            {
                index: true,
                element: <OPCreativeUpload />,
            },
        ],
    },
    {
        path: '/creativeUpload',
        title: 'Creative Upload',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.CREATIVE_UPLOAD],
        children: [
            {
                index: true,
                element: <CreativeUpload />,
            },
        ],
    },
    // {
    //   path: '/GLU',
    //   title: 'GLU',
    //   element: <LayoutContainer/>,
    //   children: [
    //     {
    //       index: true,
    //       element: <GLU/>
    //     }
    //   ]
    // },
    {
        path: '/html5_generator',
        title: 'HTML5 Generator',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.HTML5_GENERATOR],
        children: [
            {
                index: true,
                element: <Html5Generator />,
            },
        ],
    },
    {
        path: '/usage_report',
        title: 'Usage Report',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN],
        children: [
            {
                index: true,
                element: <UsageReport />,
            },
        ],
    },
    {
        path: '/userManagement',
        title: 'User Management',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.SUPER_USER],
        children: [
            {
                index: true,
                element: <UserManagement />,
            },
        ],
    },
    {
        path: '/userInfo',
        title: 'User Info',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.USER_INFO_NG],
        children: [
            {
                index: true,
                element: <UserInfoNG/>,
            },
        ],
    },
    {
        path: '/userSyncInfo1',
        title: 'User Sync Info 1',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.USER_INFO],
        children: [
            {
                index: true,
                element: <UserInfo/>,
            },
        ],
    },
    {
        path: '/userAPIInfo2',
        title: 'User API Info 2',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN,Roles.USER_INFO_V2],
        children: [
            {
                index: true,
                element: <UserInfoV2/>,
            },
        ],
    },
    {
        path: '/yandex',
        title: 'Yanedx',
        element: <LayoutContainer />,
        permission: [Roles.ADMIN, Roles.YANDEX],
        children: [
            {
                index: true,
                element: <Yandex/>,
            },
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
]
